import _ from 'lodash';
import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState
} from 'react';

interface AppImageData {
  urls?: { thumbnail: string; original: string; fullScreen: string; email: string };
  hideBannerImage?: boolean;
}

interface AppImages {
  petRecordsLogoImage?: AppImageData;
  practiceLogoImage?: AppImageData;
  mobileBannerImage?: AppImageData;
  signInImage?: AppImageData;
}

interface Context {
  appImages: AppImages;
  setAppImages: Dispatch<SetStateAction<{}>>;
}

const defaultContext: Context = {
  appImages: {},
  setAppImages: _.noop
};

export const AppImagesContext = createContext<Context>(defaultContext);

export const useAppImages = (): Context => useContext(AppImagesContext);

export const AppImagesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [appImages, setAppImages] = useState({});

  return (
    <AppImagesContext.Provider value={{ appImages, setAppImages }}>
      {children}
    </AppImagesContext.Provider>
  );
};
